/** init domain config */
import Vue from 'vue'
//设置全局API_BASE_URL
Vue.prototype.API_BASE_URL = process.env.VUE_APP_API_BASE_URL
Vue.prototype.VUE_APP_BIG_SCREEN_URL = process.env.VUE_APP_BIG_SCREEN_URL
Vue.prototype.BASE_URL = process.env.BASE_URL
Vue.prototype.VUE_APP_PLATFORM_NAME = process.env.VUE_APP_PLATFORM_NAME
Vue.prototype.VUE_TENANT_ID = process.env.VUE_APP_TENANT_ID

window._CONFIG['domianURL'] = Vue.prototype.API_BASE_URL
window._CONFIG['bigscreenUrl'] = Vue.prototype.VUE_APP_BIG_SCREEN_URL
window._CONFIG['baseURL'] = Vue.prototype.BASE_URL || ''
//单点登录地址
window._CONFIG['casPrefixUrl'] = process.env.VUE_APP_CAS_BASE_URL
window._CONFIG['onlinePreviewDomainURL'] =  process.env.VUE_APP_ONLINE_BASE_URL
window._CONFIG['staticDomainURL'] = Vue.prototype.API_BASE_URL + '/sys/common/static'
window._CONFIG['pdfDomainURL'] = Vue.prototype.API_BASE_URL+ '/sys/common/pdf/pdfPreviewIframe'

console.info('domainUrl='+window._CONFIG['domianURL']);
console.info('baseURL='+window._CONFIG['baseURL']);
console.info('bigscreenUrl='+window._CONFIG['bigscreenUrl']);
console.info('-------------------------------------------------')
console.info(window._CONFIG['domianURL'])
if(window._CONFIG['domianURL'].startsWith("/")){
  window._CONFIG['domianURL'] = location.origin + window._CONFIG['domianURL'];
  window._CONFIG['bigscreenUrl'] = Vue.prototype.VUE_APP_BIG_SCREEN_URL;
}

console.info('domainUrl='+window._CONFIG['domianURL']);
console.info('baseURL='+window._CONFIG['baseURL']);
console.info('bigscreenUrl='+window._CONFIG['bigscreenUrl']);
console.info('-------------------------------------------------')